import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Transition as _Transition, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bd53526"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex" }
const _hoisted_2 = { class: "tw-relative" }
const _hoisted_3 = {
  key: 0,
  class: "tw-flex tw-w-full tw-p-2"
}
const _hoisted_4 = {
  key: 0,
  class: "tw-flex tw-items-center tw-justify-center tw-py-4"
}
const _hoisted_5 = ["id", "data-testid"]
const _hoisted_6 = ["for"]
const _hoisted_7 = {
  key: 0,
  class: "tw-text-xs tw-text-slate-500"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioSearchInput = _resolveComponent("StudioSearchInput")!
  const _component_StudioSpinner = _resolveComponent("StudioSpinner")!
  const _component_StudioCheckbox = _resolveComponent("StudioCheckbox")!
  const _component_InfiniteScrollContainer = _resolveComponent("InfiniteScrollContainer")!
  const _directive_studio_click_outside = _resolveDirective("studio-click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "trigger", {}, undefined, true),
      _createVNode(_Transition, { name: "slide" }, {
        default: _withCtx(() => [
          (_ctx.isOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                id: "multiselect-list",
                "data-testid": "studio-multiselect",
                class: _normalizeClass(["tw-absolute tw-z-50 tw-mt-1 tw-w-72 tw-rounded-md tw-bg-white tw-py-1.5 tw-shadow-md", _ctx.extraClasses])
              }, [
                (_ctx.shouldShowSearchInput)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_StudioSearchInput, {
                        alwaysExpanded: "",
                        searchTerm: _ctx.searchTerm,
                        onOnSearch: _cache[0] || (_cache[0] = searchTerm => _ctx.$emit('onSearch', searchTerm))
                      }, null, 8, ["searchTerm"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_InfiniteScrollContainer, {
                  class: "tw-max-h-[300px] tw-space-y-1 tw-overflow-y-auto tw-pb-1 tw-text-sm",
                  pause: _ctx.isLoadingData,
                  onScrollBottom: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('scrolledToBottom')))
                }, {
                  default: _withCtx(() => [
                    (_ctx.isLoadingData && !_ctx.fetchSilently)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_StudioSpinner, {
                            size: "small",
                            coverContainer: false
                          })
                        ]))
                      : (_ctx.multiselectItems.length === 0 && !_ctx.isLoadingData)
                        ? _renderSlot(_ctx.$slots, "empty-state", { key: 1 }, undefined, true)
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.multiselectItems, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              id: item.id,
                              key: item.id,
                              "data-testid": item.id,
                              class: "tw-flex tw-items-center tw-space-x-2 tw-rounded tw-px-3 tw-py-1.5 hover:tw-bg-slate-100"
                            }, [
                              _createVNode(_component_StudioCheckbox, {
                                id: `${item.id}-checkbox`,
                                checked: item.selected,
                                "data-testid": `${item.id}-checkbox`,
                                onClick: ($event: any) => (_ctx.$emit('onToggleSelectItem', item.id))
                              }, null, 8, ["id", "checked", "data-testid", "onClick"]),
                              _createElementVNode("label", {
                                for: `${item.id}-checkbox`,
                                class: "tw-cursor-pointer tw-break-all tw-text-left tw-font-normal tw-leading-tight"
                              }, [
                                _createTextVNode(_toDisplayString(item.title) + " ", 1),
                                (item.subtitle)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                      _hoisted_8,
                                      _createTextVNode(" " + _toDisplayString(item.subtitle), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_6)
                            ], 8, _hoisted_5))
                          }), 128)),
                    _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
                  ]),
                  _: 3
                }, 8, ["pause"])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ])
  ])), [
    [_directive_studio_click_outside, _ctx.closeMultiselect]
  ])
}